
<template>
  <a-drawer
    :title="title"
    placement="right"
    :width="600"
    :closable="false"
    :visible="visible"
    @close="handleClose"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
      <a-form-item label="财务软件名称">
        <a-input
            v-decorator="[
            'softwareName',
            { rules: [{ required: true, message: '财务软件名称不能为空!' }] },

          ]"
            placeholder="请输入财务软件名称"
        />
      </a-form-item>
      <a-form-item label="科目编码">
        <a-input v-decorator="['sourceSubNo']" disabled   value="科目编码"/>
      </a-form-item>
      <a-form-item label="企业科目编码">
        <a-input
            v-decorator="[
            'destSubNo',
            { rules: [{ required: true, message: '企业科目编码不能为空!' }] },
          ]"
            placeholder="请输入企业科目编码"
        />
      </a-form-item>

      <a-form-item label="科目名称">
        <a-input v-decorator="['sourceSubName']" disabled />
      </a-form-item>
      <a-form-item label="企业科目名称">
        <a-input
            v-decorator="[
            'destSubName',
            { rules: [{ required: true, message: '企业科目名称不能为空!' }] },
          ]"
            placeholder="请输入企业科目名称"
        />
      </a-form-item>
<!--      <a-form-item label="期初余额-方向">-->
<!--        <a-input v-decorator="['sourceOpenType']" disabled />-->
<!--      </a-form-item>-->
<!--      <a-form-item label="企业期初余额-方向">-->
<!--        <a-input v-decorator="[ 'destOpenType' ]" placeholder="请输入企业期初余额-方向" />-->
<!--      </a-form-item>-->

      <a-form-item label="期初余额">
        <a-input v-decorator="['sourceOpenBal']" disabled />
      </a-form-item>
      <a-form-item label="企业期初余额(年)">
        <a-input
            v-decorator="[
            'destOpenBal',
            { rules: [{ required: true, message: '企业期初余额(年)不能为空!' }] },
          ]"
            placeholder="请输入企业期初余额(年)"
        />
      </a-form-item>
      <a-form-item label="企业期初余额(季)">
        <a-input
            v-decorator="[
            'destOpenBalQ',
            { rules: [{ required: true, message: '企业期初余额(季)不能为空!' }] },
          ]"
            placeholder="请输入企业期初余额(季)"
        />
      </a-form-item>
      <a-form-item label="企业期初余额(月)">
        <a-input
            v-decorator="[
            'destOpenBalM',
            { rules: [{ required: true, message: '企业期初余额(月)不能为空!' }] },
          ]"
            placeholder="请输入企业期初余额(月)"
        />
      </a-form-item>

        <a-form-item label="本期借方">
          <a-input v-decorator="['sourceCurrentDebit']" disabled />
        </a-form-item>
        <a-form-item label="企业本期借方(年)">
          <a-input
              v-decorator="[
            'destCurrentDebit',
            { rules: [{ required: true, message: '企业本期借方(年)不能为空!' }] },
          ]"
              placeholder="请输入企业本期借方(年)"
          />
      </a-form-item>
      <a-form-item label="企业本期借方(季)">
        <a-input
            v-decorator="[
            'destCurrentDebitQ',
            { rules: [{ required: true, message: '企业本期借方(季)不能为空!' }] },
          ]"
            placeholder="请输入企业本期借方(季)"
        />
      </a-form-item>
      <a-form-item label="企业本期借方(月)">
        <a-input
            v-decorator="[
            'destCurrentDebitM',
            { rules: [{ required: true, message: '企业本期借方(月)不能为空!' }] },
          ]"
            placeholder="请输入企业本期借方(月)"
        />
      </a-form-item>

        <a-form-item label="本期贷方">
          <a-input v-decorator="['sourceCurrentCredit']" disabled />
        </a-form-item>

        <a-form-item label="企业本期贷方(年)">
          <a-input
              v-decorator="[
            'destCurrentCredit',
            { rules: [{ required: true, message: '企业本期贷方(年)不能为空!' }] },
          ]"
              placeholder="请输入企业本期贷方(年)"
          />
        </a-form-item>
      <a-form-item label="企业本期贷方(季)">
        <a-input
            v-decorator="[
            'destCurrentCreditQ',
            { rules: [{ required: true, message: '企业本期贷方(季)不能为空!' }] },
          ]"
            placeholder="请输入企业本期贷方(季)"
        />
      </a-form-item>
      <a-form-item label="企业本期贷方(月)">
        <a-input
            v-decorator="[
            'destCurrentCreditM',
            { rules: [{ required: true, message: '企业本期贷方(月)不能为空!' }] },
          ]"
            placeholder="请输入企业本期贷方(月)"
        />
      </a-form-item>

<!--      <a-form-item label="期末余额-方向">-->
<!--        <a-input v-decorator="['sourceEndType']" disabled />-->
<!--      </a-form-item>-->

<!--      <a-form-item label="企业期末余额-方向">-->
<!--        <a-input-->
<!--            v-decorator="[ 'destEndType' ]"-->
<!--            placeholder="请输入企业期末余额-方向"-->
<!--        />-->
<!--      </a-form-item>-->
      <a-form-item label="期末余额(年)">
        <a-input v-decorator="['sourceEndBal']" disabled />
      </a-form-item>

      <a-form-item label="企业期末余额(年)">
        <a-input
            v-decorator="[
            'destEndBal',
            { rules: [{ required: true, message: '企业期末余额(年)不能为空!' }] },
          ]"
            placeholder="请输入企业期末余额(年)"
        />
      </a-form-item>
      <a-form-item label="企业期末余额(季)">
        <a-input
            v-decorator="[
            'destEndBalQ',
            { rules: [{ required: true, message: '企业期末余额(季)不能为空!' }] },
          ]"
            placeholder="请输入企业期末余额(季)"
        />
      </a-form-item>
      <a-form-item label="企业期末余额(月)">
        <a-input
            v-decorator="[
            'destEndBalM',
            { rules: [{ required: true, message: '企业期末余额(月)不能为空!' }] },
          ]"
            placeholder="请输入企业期末余额(月)"
        />
      </a-form-item>
    </a-form>
    <div
      :style="{
        position: 'absolute',
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e8e8e8',
        padding: '10px 16px',
        textAlign: 'right',
        left: 0,
        background: '#fff',
        borderRadius: '0 0 4px 4px',
      }"
    >
      <a-button style="margin-right: 8px" @click="handleClose">取消</a-button>
      <a-button type="primary" @click="handleSave">确定</a-button>
    </div>
  </a-drawer>
</template>
<script>
import pick from "lodash.pick";
import { createSoftWareMap,updateSoftWareMap } from "@/api/softmap";
export default {
  name: "softWareMapModal",
  data() {
    return {
      sourceSubNo: "科目编码",
      sourceSubName: "科目名称",
      sourceOpenType: "期初余额-方向",
      sourceOpenBal: "期初余额",
      sourceCurrentDebit: "本期借方",
      sourceCurrentCredit: "本期贷方",
      sourceEndType: "期末余额-方向",
      sourceEndBal: "期末余额",
      status: 1,
      visible: false,
      record: {},
      form: this.$form.createForm(this, { name: "form" }),
      confirmLoading: false,
      loadedKeys: [],
      treeData: [],
      roleList: [],
      positionList: [],
    };
  },
  methods: {
    onLoad(loadedKeys) {
      this.loadedKeys = loadedKeys;
    },
    async show(status, record) {
      this.status = status;
      this.visible = true;
      if (record) {
        let that = this;
        that.record = record;
        that.$nextTick(() => {
          that.form.setFieldsValue(
            pick(
              record,
              "softwareName",
              "sourceSubNo",
              "destSubNo",
              "sourceSubName",
              "destSubName",
              // "sourceOpenType",
              // "destOpenType",
              "sourceOpenBal",
              "destOpenBal",
                "destOpenBalQ",
                "destOpenBalM",
              "sourceCurrentDebit",
              "destCurrentDebit",
                "destCurrentDebitQ",
                "destCurrentDebitM",
              "sourceCurrentCredit",
              "destCurrentCredit",
                "destCurrentCreditQ",
                "destCurrentCreditM",
              // "sourceEndType",
              // "destEndType",
              "sourceEndBal",
              "destEndBal",
                "destEndBalQ",
                "destEndBalM",
            )
          );
        });
      }
    },
    handleSave() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let res;
          if (this.status == 2) {
            debugger;
            res = await createSoftWareMap(values);
          } else {
            res = await   updateSoftWareMap(Object.assign(this.record, values));
          }
          if (res.status == 200) {
            this.visible = false;
            this.$message.success(this.status == 2 ? "创建成功" : "修改成功");
            this.$emit("reload");
          } else {
            this.$notification.error({
              message: "系统提示",
              description: res.msg || res.message,
              duration: 4,
            });
          }
        }
      });
    },
    handleClose() {
      this.form.resetFields();
      this.visible = false;
    },
  },
};
</script>
<style lang="less" scoped></style>
